module.exports = __webpack_public_path__ + "img/accessory_item_15.a146f7aa.svg";